export const PROPERTY_PANEL_ANCHOR_ID = "node-properties-panel-anchor";
